import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  titleId: string;
  descriptionId: string;
  icon: ReactNode;
  children?: ReactNode;
}

export default function SummaryHeader({ titleId, descriptionId, icon, children }: Props) {
  return (
    <div className="flex items-start gap-3">
      <div className="mt-0.5 flex h-8 w-8 items-center justify-center rounded-lg bg-slate-900 text-white">
        {icon}
      </div>
      <div>
        <p className="text-sm font-semibold text-slate-900">
          <FormattedMessage id={titleId} />
        </p>
        <p className="mt-1 text-sm text-slate-600">
          <FormattedMessage id={descriptionId} />
        </p>
        {children}
      </div>
    </div>
  );
}
